import { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * /embed/badge/:slug — minimal page with just the badge image.
 * No nav/footer (handled by AppLayout's hideChrome check on /embed/* paths).
 * Designed to be loaded inside an <iframe> on a business owner's website.
 */
export default function BadgeEmbedPage() {
  const { slug } = useParams();
  const target = `/badge/${slug}`;
  const imgSrc = "/assets/localbest-verified-badge.png";
  const webpSrc = "/assets/localbest-verified-badge.webp";

  useEffect(() => {
    document.body.style.background = "transparent";
    document.body.style.margin = "0";
    return () => {
      document.body.style.background = "";
      document.body.style.margin = "";
    };
  }, []);

  return (
    <div
      style={{
        background: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: 0,
        margin: 0,
      }}
    >
      <a
        href={target}
        target="_top"
        rel="noopener noreferrer"
        title="Visit My Verified LocalBest.ai Page"
        aria-label="LocalBest Verified Badge"
        style={{ display: "block", maxWidth: "100%" }}
        data-testid="embed-badge-link"
      >
        <picture>
          <source srcSet={webpSrc} type="image/webp" />
          <img
            src={imgSrc}
            alt="LocalBest Verified Badge"
            title="Visit My Verified LocalBest.ai Page"
            style={{ maxWidth: "100%", width: "360px", height: "auto", border: 0, display: "block" }}
            loading="lazy"
          />
        </picture>
      </a>
    </div>
  );
}
